import React from "react";

const ForwardSecondsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <defs>
        <clipPath id="clipPath9600556897">
          <path
            d="M0 0L28 0L28 28L0 28L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath9600556897)">
        <path
          d="M16.3333 14C16.3333 17.8617 13.195 21 9.33333 21C5.47167 21 2.33333 17.8617 2.33333 14C2.33333 10.1383 5.47167 7 9.33333 7L9.33333 11.6667L15.1667 5.83333L9.33333 0L9.33333 4.66667C4.17667 4.66667 0 8.84333 0 14C0 19.1567 4.17667 23.3333 9.33333 23.3333C14.49 23.3333 18.6667 19.1567 18.6667 14L16.3333 14Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 4.66667 1.16667)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M2.17 5.04078L2.17 0.0591124L2.065 0.0591124L0 0.794112L0 1.59911L1.17833 1.23744L1.17833 5.04078L2.17 5.04078ZM3.79167 2.12411L3.79167 2.98744C3.79167 5.20411 5.32 5.11078 5.47167 5.11078C5.635 5.11078 7.15167 5.21578 7.15167 2.98744L7.15167 2.12411C7.15167 -0.0925543 5.62334 0.000778834 5.47167 0.000778834C5.30833 0.000778834 3.79167 -0.104221 3.79167 2.12411ZM6.17167 1.98411L6.17167 3.11578C6.17167 4.01411 5.92667 4.31744 5.48333 4.31744C5.04 4.31744 4.78333 4.01411 4.78333 3.11578L4.78333 1.98411C4.78333 1.10911 5.04 0.805778 5.47167 0.805778C5.915 0.794111 6.17167 1.10911 6.17167 1.98411Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 10.5 13.5559)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default ForwardSecondsIcon;
